import Vue from "vue"
import './plugins/axios'
import store from "./store"
import Router from "vue-router"

import routes from "./common/config/router.js"

Vue.use(Router)

let router = new Router({
	routes
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
// 全局前置守卫
router.beforeEach((to, from, next) => {
	// 获取token
	let token = window.sessionStorage.getItem('token')
	let user = window.sessionStorage.getItem('user')
	if (token) { // 已登录
		// 防止重复登录
		if (to.path === '/login') {
			Vue.prototype.$message.error('请不要重复登录');
			return next({
				name: from.name ? from.name : 'index'
			})
		}
		// 其他验证...
		if (to.name !== 'error_404') {
			var userxx = JSON.parse(user)
			axios.post('/admin/manager/getManagerInfo', {
				user_id: userxx.id
			}, {
				token: true
			}).then((res) => {
				let data = res.data.data
				store.commit('login', data)
				// 存储权限规则
				if (data.role && data.role.rules) {
					window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules))
				}
				// 生成后台菜单
				store.commit('createNavBar', data.tree)
			}).catch((error) => {})
			// 超级管理员跳过验证
			if (user) {
				user = JSON.parse(user)
				if (user.super === 1) {
					return next()
				}
			}
			// 验证
			let rules = window.sessionStorage.getItem('rules')
			rules = rules ? JSON.parse(rules) : []
			//拿角标：用去的路由对比规则内限制的路由
			let index = rules.findIndex(item => {
				return item.rule_id > 0 && item.desc === to.name
			})
			//-1：没有权限进入
			if (index === -1) {
				Vue.prototype.$message.error('你没有权限')
				return next({
					name: from.name ? from.name : 'error_404'
				})
			}
		}
		next();
	} else {
		// 跳过登录页验证
		if (to.path === '/login' || to.path === '/register' || to.path === '/tks/Lineysbh' || to.path === '/tks/service' || to.path === '/register/choose' || to.path === '/register/forgetpwd') {
			return next();
		}
		// 未登录
		// Vue.prototype.$message.error('请先登录');
		next({
			path: '/login'
		})
	}
})





export default router